import { h } from 'preact'
import { useContext, useEffect, useState } from 'preact/hooks'
import { CSSProperties, ForwardFn, forwardRef } from 'preact/compat'

import { Button } from 'components/ui'
import { useTranslation } from 'scripts/hooks'
import BaseContext from 'contexts/base-context'

import FieldsContext from '../../../fieldsContext'
import classes from './nextPage.scss'

type NextPageProps = {
  disabled?: boolean
  onNext?(): void
  persistClick?: boolean
  style?: CSSProperties
}

const NextPage: ForwardFn<NextPageProps, HTMLDivElement> = (props, ref) => {
  const { interactive } = useContext(BaseContext)
  const { disabled = false, onNext, style, persistClick } = props
  const { isLastPage, isDynamicLastPage } = useContext(FieldsContext)!
  const [showSubmit, setShowSubmit] = useState(isLastPage)
  const t = useTranslation()

  useEffect(() => {
    isDynamicLastPage !== undefined ? setShowSubmit(isDynamicLastPage) : setShowSubmit(isLastPage)
  }, [isDynamicLastPage])

  return (
    <div className={`${classes.nextPage} ${interactive ? '' : 'pointer-events-none'}`} ref={ref} style={style}>
      <Button onClick={onNext} disabled={disabled || !interactive} persistClick={persistClick}>
        {showSubmit ? t('submitButton') : t('nextButton')}
      </Button>
    </div>
  )
}

export default forwardRef(NextPage)
